// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U2ov","menu":"styles_menu__3Guhg"};